import { Component, OnInit } from '@angular/core';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { RegisterModel } from 'src/app/models/login/login.model';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  registeruser: RegisterModel = new RegisterModel();
  Loader: boolean = false;
  loginResponse: any;
  registerForm: boolean = true;
  registerDemo: boolean = false;

  constructor(private alertify: AlertifyService, private activatedRoute: ActivatedRoute, private router: Router, private _loginService: LoginService) {
    this.registeruser = new RegisterModel();

  }

  ngOnInit() {
  }
  onSubmit(): void {
    if (this.registeruser.FirstName == undefined || this.registeruser.FirstName == null || this.registeruser.FirstName == "") {
      this.alertify.error("First Name is required");
      return;
    }
    if (this.registeruser.LastName == "" || this.registeruser.LastName == null || this.registeruser.LastName == undefined) {
      this.alertify.error("Last Name is required");
      return;
    }
    if (this.registeruser.Email == "" || this.registeruser.Email == null || this.registeruser.Email == undefined) {
      this.alertify.error("Email is required");
      return;
    }
    if (this.registeruser.Password == "" || this.registeruser.Password == null || this.registeruser.Password == undefined) {
      this.alertify.error("Password is required");
      return;
    }
    this.Loader = true;
    this.registerForm = true;
    this.registerDemo = false;
    this._loginService.Register(this.registeruser).subscribe(res => {
      var responseData = JSON.parse(res._body);
      if (responseData.isSuccess) {
        this.registeruser = responseData.responseData;
        this.Loader = false;
        this.registerForm = false;
        this.registerDemo = true;
      }
      else {
        this.alertify.error(responseData.responseMessage);
      }
      this.Loader = false;

    }
    )
  }
  signUp() {
    this.router.navigate(['/login']);
  }
}





